module.exports = __webpack_public_path__ + "img/hoslogo14.43141757.png";